import { Link } from "react-router-dom";
import { PageHero } from "../components/common/SectionHeading";
import { FaqList } from "../components/sections/FaqList";
import { ROUTES } from "../config/routes";
import { usePageTitle } from "../lib/usePageTitle";

export default function FaqPage() {
  usePageTitle("FAQ");
  return (
    <>
      <PageHero label="FAQ" title="Questions, answered." body="Everything you need to know about CARLINK, the sticker and your privacy." />
      <section className="section-pad !pt-16">
        <div className="container-x grid gap-12 lg:grid-cols-[1fr_2fr]">
          <div>
            <p className="text-slate-400">Can't find what you're looking for?</p>
            <Link to={ROUTES.CONTACT} data-testid="faq-contact-link" className="mt-3 inline-block font-display font-semibold text-[#FF5500] underline-offset-4 hover:underline focus-ring rounded">Contact the CARLINK team →</Link>
          </div>
          <FaqList />
        </div>
      </section>
    </>
  );
}
